import React from 'react';
import PropTypes from 'prop-types';
const editableColumns = {"market_key": "number",
    "description": "string",
    "order_no": "number",
    "account_id": "number",
    "outlets_id": "number",
    "geography_level_id": "number",
    "geography_type_id": "number",
    "legacy_account_type_id": "number",
    "account_type_id": "number",
    "releasability_id": "number",
    "weekly_releasability_id": "number",
    "measure_availability_id": "number",
    "control_brand": "True/False",
    "geography_composition_id":"number",
    "iri_hicone_market": "True/False",
    "retailer_corporate_totals": "True/False",
    "market_group_id": "number",
    "activate_for_distribution_tracker": "True/False",
    "geography_store_level_allowability_id": "True/False",
    "secondary_outlets": "List of outlets_id"};
const DownloadDropdownOptionsButton = ({
                                           outletsDropdown,
                                           accountDropdown,
                                           legacyAccountTypeDropdown,
                                           geographyLevelDropdown,
                                           accountTypeDropdown,
                                           geographyTypeDropdown,
                                           geographyCompositionDropdown,
                                           releasabilityDropdown,
                                           weeklyReleasabilityDropdown,
                                           measureAvailabilityDropdown,
                                           geoStoreLevelAllowabilityDropdown
                                       }) => {

    const generateExcelXML = () => {
        const sheets = [
            {
                name: 'template',
                columns: Object.keys(editableColumns),
                values: Object.values(editableColumns)
            },
            {name: 'outlets', data: outletsDropdown},
            {name: 'account', data: accountDropdown},
            {name: 'legacyAccountType', data: legacyAccountTypeDropdown},
            {name: 'geographyLevel', data: geographyLevelDropdown},
            {name: 'accountType', data: accountTypeDropdown},
            {name: 'geographyType', data: geographyTypeDropdown},
            {name: 'geographyComposition', data: geographyCompositionDropdown},
            {name: 'releasability', data: releasabilityDropdown},
            {name: 'weeklyReleasability', data: weeklyReleasabilityDropdown},
            {name: 'measureAvailability', data: measureAvailabilityDropdown},
            {name: 'geoStoreLevelAllowability', data: geoStoreLevelAllowabilityDropdown}
        ];

        let xml = `<?xml version="1.0"?>
        <?mso-application progid="Excel.Sheet"?>
        <Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
         xmlns:o="urn:schemas-microsoft-com:office:office"
         xmlns:x="urn:schemas-microsoft-com:office:excel"
         xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"
         xmlns:html="http://www.w3.org/TR/REC-html40">
         <Styles>
          <Style ss:ID="Default" ss:Name="Normal">
           <Alignment ss:Vertical="Bottom"/>
           <Borders/>
           <Font ss:FontName="Calibri" x:Family="Swiss" ss:Size="11" ss:Color="#000000"/>
           <Interior/>
           <NumberFormat/>
           <Protection/>
          </Style>
          <Style ss:ID="s62">
           <Font ss:FontName="Calibri" x:Family="Swiss" ss:Size="11" ss:Color="#000000" ss:Bold="1"/>
          </Style>
         </Styles>`;

        sheets.forEach(sheet => {
            xml += `
 <Worksheet ss:Name="${escapeXml(sheet.name)}">
  <Table>`;
            
            if (sheet.name === 'template') {
                xml += `
   <Row ss:StyleID="s62">`;
                sheet.columns.forEach(col => {
                    xml += `
    <Cell><Data ss:Type="String">${escapeXml(col)}</Data></Cell>`;
                });
                xml += `
   </Row>
   <Row>`;
                sheet.values.forEach(val => {
                    xml += `
    <Cell><Data ss:Type="String">${escapeXml(val)}</Data></Cell>`;
                });
                xml += `
   </Row>`;
            } else {
                xml += `
   <Column ss:Width="150"/>
   <Column ss:Width="100"/>
   <Row ss:StyleID="s62">
    <Cell><Data ss:Type="String">Name</Data></Cell>
    <Cell><Data ss:Type="String">Index</Data></Cell>
   </Row>`;

                if (sheet.data && sheet.data.length > 0) {
                    sheet.data.forEach(item => {
                        xml += `
   <Row>
    <Cell><Data ss:Type="String">${escapeXml(item.label)}</Data></Cell>
    <Cell><Data ss:Type="Number">${isNaN(item.value) ? 0 : item.value}</Data></Cell>
   </Row>`;
                    });
                }
            }

            xml += `
  </Table>
 </Worksheet>`;
        });

        xml += `
</Workbook>`;
        return xml;
    };

    const escapeXml = (unsafe) => {
        if (unsafe === null || unsafe === undefined) return "";
        return unsafe.toString()
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&apos;');
    };

    const downloadExcel = () => {
        const xml = generateExcelXML();
        const blob = new Blob(['\ufeff', xml], {type: 'application/vnd.ms-excel;charset=utf-8'});
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'MarketServiceTemplate.xls';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    return (
        <div title={'Download Template'}>
            <i className={'fas fa-layer-group'}
               onClick={downloadExcel}
               data-testid="download-dropdown-options-button"
            />
        </div>
    );
};

DownloadDropdownOptionsButton.propTypes = {
    outletsDropdown: PropTypes.array,
    accountDropdown: PropTypes.array,
    legacyAccountTypeDropdown: PropTypes.array,
    geographyLevelDropdown: PropTypes.array,
    accountTypeDropdown: PropTypes.array,
    geographyTypeDropdown: PropTypes.array,
    geographyCompositionDropdown: PropTypes.array,
    releasabilityDropdown: PropTypes.array,
    weeklyReleasabilityDropdown: PropTypes.array,
    measureAvailabilityDropdown: PropTypes.array,
    geoStoreLevelAllowabilityDropdown: PropTypes.array
};

export default DownloadDropdownOptionsButton;
